import type { HandleWebhookBodyMetadata } from './handleWebhookBodyMetadata';

export type HandleWebhookBody = {
  /** 결제 금액 */
  amount?: number;
  /** 통화 */
  currency?: string;
  /** 이벤트 타입 */
  eventType: string;
  /** 추가 메타데이터 */
  metadata?: HandleWebhookBodyMetadata;
  /** 주문 ID */
  orderId?: string;
  /** 결제 수단 */
  paymentMethod?: string;
  /** 상태 */
  status?: string;
  /** 이벤트 발생 시간 */
  timestamp?: string;
};
